import { format, parse } from "date-fns";
import { type ApplicationFormValue, type PlanData } from "@/components/fragments/argyle";
import { type CreateCustomerInput } from "@/gql/generated/graphql.gen";
import { removeHyphen } from "@/modules/utils/normalize-strings";

export const getCreateCustomerInput = (
  applicationFormValue: ApplicationFormValue,
  promotionCode: string | undefined,
  planData: PlanData,
): CreateCustomerInput => {
  const { child, customerAddress, shippingAddress, shippingAddressSameOrNew, specialNote } = applicationFormValue;

  return {
    priceUuid: planData.id,
    customerAddress: {
      ...customerAddress,
      prefectureCode: Number(customerAddress.prefectureCode),
      postalCode: removeHyphen(customerAddress.postalCode),
    },
    shippingAddress:
      shippingAddressSameOrNew === "new"
        ? {
            ...shippingAddress,
            prefectureCode: Number(shippingAddress.prefectureCode),
            postalCode: removeHyphen(shippingAddress.postalCode),
          }
        : {
            ...customerAddress,
            prefectureCode: Number(customerAddress.prefectureCode),
            postalCode: removeHyphen(customerAddress.postalCode),
          },
    child: {
      birthDate: format(parse(child.birthDate, "yyyyMMdd", new Date()), "yyyy-MM-dd"),
      sexCode: Number(child.sexCode),
    },
    specialNote,
    promotionCode,
  };
};
